import { showSuccessNotification } from '@/utils/notifications';

export default function displayEnterTip() {
  const KEY = "textmanager.000100.displayed-enter-tip";
  const value = localStorage.getItem(KEY);
  const lastDisplayed = value && new Date(value);
  const now = new Date();
  const day = 86400000;
  const diplayAfterXDays = 3;

  if (!lastDisplayed || lastDisplayed.getTime() < (now.getTime() - (day * diplayAfterXDays))) {
    localStorage.setItem(KEY, now.toISOString());
    showSuccessNotification("tip: Press CTRL + Enter to submit");
  }
}
